import React, { useState } from 'react';
import { WorkingHoursType } from 'utils/types';
import WorkingHours from 'components/working-hours';
import PageHeaderText from 'components/base/page-header-text';
import SingleBottomNav from 'components/base/single-bottom-nav';
import moment from 'moment';
import { formatTimeToApiFormat, getWorkingHoursComponentFormatFromApi } from 'utils/functions';
import { days } from 'utils/constants';
import { apiService } from 'services/base.service';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const MultipleBrandWorkingHours = () => {
  const location = useLocation();
  const brandIds = location.state;
  const brand_working_hours = getWorkingHoursComponentFormatFromApi(days());

  const [workingHours, setWorkingHours] = useState<WorkingHoursType[]>(brand_working_hours);
  const [loading, setLoading] = useState(false);
  const handleConfirm = async () => {
    setLoading(true);

    const workingHoursFormat = workingHours?.map((item: any) => {
      const opening_time = formatTimeToApiFormat(item.opening_time);
      const closing_time = formatTimeToApiFormat(item.closing_time);

      return {
        name: item.name.toLowerCase(),
        opening_time: moment(opening_time, 'HH:mm:ss').format('HH:mm:ss'),
        closing_time: moment(closing_time, 'HH:mm:ss').format('HH:mm:ss'),
        active: item.active
      };
    });
    try {
      const res = await apiService.post(`marketing/brand/working-hours-multiple-brands`, {
        data: { brand_ids: brandIds, days: workingHoursFormat }
      });
      if (res?.data) {
        toast(<ToastMessage type='success' message='Brands successfully updated' />);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message='Error updating brands' />);
    }
    setLoading(false);
  };

  return (
    <div>
      <PageHeaderText
        title='Edit Selected Brands'
        description='Update the opening & close time of selected brands'
      />
      <WorkingHours data={workingHours} setData={setWorkingHours} />
      <SingleBottomNav onConfirm={handleConfirm} loading={loading} />
    </div>
  );
};

export default MultipleBrandWorkingHours;
